// extracted by mini-css-extract-plugin
export default {"container":"VotingCard_container__MD8cw","walletContainer":"VotingCard_walletContainer__-vFqu","countDown":"VotingCard_countDown__GNDRA"};